<template>
    <div>
        <div v-if="loading" class="text-center" style="padding: 40px 0;">
            <font-awesome-icon :icon="['fas', 'spinner']" spin size="2x" />
        </div>
        <div v-else>
            <h3 class="h6 text-muted mb-4">Solstices &amp; Equinoxes</h3>
            <div class="row">
                <div class="col-md-3" v-for="event in seasons" :key="event.id">
                    <div class="card w-100 margin-botton-20" style="width: 18rem;">
                        <div class="card-body event-card-bg">
                            <h3 class="h5 card-title" style="margin-bottom: 0; padding-bottom: 0">{{ event.name }}</h3>
                            <p v-if="event.subtitle" class="text-muted small mb-0" style="margin-top: 2px;">{{ event.subtitle }}</p>
                            <p style="font-size: 64px; margin:0; padding:0;">{{ event.symbol }}</p>
                            <p class="card-text">{{ event.short_literal_date }} at {{ event.time }}</p>
                            <p class="card-text small">{{ event.naturaltime }}</p>
                            <p class="card-text small">Duration {{ event.duration_days }} days</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3" v-if="seasons.length">
                <div class="col-12">
                    <div class="card w-100 margin-botton-20">
                        <div class="card-body event-card-bg">
                            <SeasonChart :seasons="seasons" title="Seasons" :subtitle="chartSubtitle" :subtitle2="chartSubtitle2" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3" v-if="seasonRows.length">
                <div class="col-12">
                    <div class="card w-100 margin-botton-20">
                        <div class="card-body event-card-bg">
                            <h3 class="h4 card-title mb-3">{{ seasonYearLabel }}</h3>
                            <div class="table-responsive">
                            <table class="table table-sm table-striped mb-0">
                                <thead>
                                    <tr>
                                        <th class="text-start">Date</th>
                                        <th class="text-start">Season</th>
                                        <th class="text-start">Event</th>
                                        <th class="text-center">Time</th>
                                        <th class="text-end">Duration</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="row in seasonRows" :key="row.season">
                                        <td class="text-start">{{ row.date }}</td>
                                        <td class="text-start">{{ row.season }}</td>
                                        <td class="text-start">{{ row.event }}</td>
                                        <td class="text-center">{{ row.time }}</td>
                                        <td class="text-end">{{ row.duration }} days</td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import astroTabMixin from '@/mixins/astroTab'
import astra from '@/api/astra'
import SeasonChart from './SeasonChart'

export default {
    name: 'TabSeasons',
    mixins: [astroTabMixin],
    components: { SeasonChart },
    props: {
        active: { type: Boolean, default: false },
    },
    data() {
        return {
            loading: true,
            seasons: [],
        }
    },
    computed: {
        chartSubtitle() {
            if (!this.city || !this.city.name) return ''
            const parts = [this.city.name]
            if (this.city.region_name) parts.push(this.city.region_name)
            return 'near ' + parts.join(', ')
        },
        chartSubtitle2() {
            if (!this.date) return ''
            return 'for ' + String(this.date.getFullYear())
        },
        seasonRows() {
            return this.seasons.map(event => ({
                season: event.name,
                event: event.subtitle,
                date: event.short_literal_date,
                time: event.time,
                duration: event.duration_days,
            }))
        },
        seasonYearLabel() {
            if (!this.date) return ''
            return String(this.date.getFullYear())
        },
    },
    watch: {
        active(val) { if (val) this.load() },
        city()      { if (this.active) this.load() },
        date()      { if (this.active) this.load() },
    },
    mounted() {
        if (this.active) this.load()
    },
    methods: {
        async load() {
            if (!this.latitude || !this.longitude || !this.timezone) return
            if (this.apiLocked) return
            this.loading = true
            await Promise.allSettled([
                astra.fetchSeasons({ ...this.loc, ...this.yearlyRange }).then(r => { this.seasons = r.data.events }),
            ])
            this.loading = false
        },
    },
}
</script>

<style scoped>
.margin-botton-20 { margin-bottom: 20px; }
.table-responsive td,
.table-responsive th { white-space: nowrap; }
</style>
